import axios from "axios"

const a = 'http://ilandertech.com/api/index.php/Welcome/'

export const RegisterApi = (data)=>{
   return axios.post(a+"AddStuRegister",data)
}

export const LoginApi = (data)=>{
    return axios.post(a+"StuLogin",data)
}

export const GetUsers = ()=>{
    return axios.get(a+"getStuUsers")
}